import { render, staticRenderFns } from "./_RevisionHistoryDialog.vue?vue&type=template&id=384b9e45&scoped=true&"
import script from "./_RevisionHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./_RevisionHistoryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384b9e45",
  null
  
)

export default component.exports